export interface DeviceInfo {
  memoryFootprint?: number;
  modelIdentifier?: string;
  modelName?: string;
  screen: {
    height: number;
    width: number;
  };
  locale: string;
  userAgent: string;
}

export function getDeviceInfo(): DeviceInfo | undefined {
  // Server Side Rendering check
  if (typeof navigator === 'undefined' || typeof performance === 'undefined') {
    return undefined;
  }

  return {
    // eslint-disable-next-line compat/compat
    memoryFootprint: performance.memory?.usedJSHeapSize,
    screen: {
      height: screen?.height,
      width: screen?.width,
    },
    userAgent: navigator.userAgent,
    locale: navigator.language,
  };
}

declare global {
  interface Performance {
    memory?: {
      usedJSHeapSize?: number;
    };
  }
}
